import React from 'react';
import PersonalInfo from './Profile/PersonalInfo';
import '../../styles/Profile.css';
import { Helmet } from 'react-helmet';
import { ConfigProvider, Tabs, Spin  } from 'antd';
import EducationInfo from './Profile/EducationInfo';
import EmploymentInfo from './Profile/EmploymentInfo';
import RelativesInfo from './Profile/RelativesInfo';
import AdditionalInfo from './Profile/AdditionalInfo';

const Profile = ({ selectors, formData, setFormData, educationData, setEducationData, languageData, setLanguageData, computerSkillsData, setComputerSkillsData, coursesData, setCoursesData, employmentData, setEmploymentData, relativesData, setRelativesData, RegistrationAddress, setRegistrationAddress, ResidenceAddress, setResidentialAddress, ShiftMode, setShiftWorkReady, Prosecution, setLegalIssues }) => {
	
	return (
		<ConfigProvider
			theme={{
				components: {
					Select: {
						optionFontSize: '12px'
					}
				},
			}}
		>	
			<Tabs
				defaultActiveKey="1"
				type="card"
				size="small"
				items={[
					{
						label: 'Персональные данные',
						key: 'personal',
						children: <PersonalInfo 
							formData={formData} 
							setFormData={setFormData}
							selectors={selectors}
							registrationAddress={RegistrationAddress}
							residentialAddress={ResidenceAddress}
							setRegistrationAddress={setRegistrationAddress}
							setResidentialAddress={setResidentialAddress} />,
					},
					{
						label: 'Образование',
						key: 'education',
						children: <EducationInfo
							educationData={educationData}
							languageData={languageData}
							computerSkillsData={computerSkillsData}
							coursesData={coursesData}
							setEducationData={setEducationData}
							setLanguageData={setLanguageData}
							setComputerSkillsData={setComputerSkillsData}
							setCoursesData={setCoursesData}
							selectors={selectors} />,
					},
					{
						label: 'Трудовая деятельность',
						key: 'labour',
						children: <EmploymentInfo
							employmentData={employmentData}
							setEmploymentData={setEmploymentData}
							selectors={selectors} />,
					},
					{
						label: 'Сведения о близких родственниках',
						key: 'relations',
						children: <RelativesInfo
							relativesData={relativesData}
							setRelativesData={setRelativesData}
							selectors={selectors} />,
					},
					{
						label: 'Дополнительные сведения',
						key: 'additional',
						children: <AdditionalInfo 
						shiftWorkReady={ShiftMode} 
						setShiftWorkReady={setShiftWorkReady} 
						legalIssues={Prosecution} 
						setLegalIssues={setLegalIssues} />,
					},
				]}
			/>
		</ConfigProvider>
	);
};

export default Profile;
